export default "__VITE_ASSET__CtYgBIWX__"